import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Bank } from '../models/bank.model';
import { ToastrService } from 'ngx-toastr';
import { loadStripe, Stripe, StripeEmbeddedCheckout } from '@stripe/stripe-js';

declare const $: any;

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  readonly rootURL = environment.ImpataAppAPIRoot;
  stripePromise: Promise<Stripe | null> = loadStripe(environment.stripePK);
  checkout!: StripeEmbeddedCheckout;

  constructor(private http: HttpClient) { }

  initiateModulePayment(moduleId,batchId){
    return this.http.post(`${this.rootURL}payment/initiatemodulepayment`, { moduleId,batchId }, {headers: new HttpHeaders({ "content-type": "application/json", "accept": "application/json" })});
  }

  initiatePackagePayment(packageId){
    return this.http.post(`${this.rootURL}payment/initiatepackagepayment`, { packageId }, {headers: new HttpHeaders({ "content-type": "application/json", "accept": "application/json" })});
  }

  getBanks(){
    return this.http.get<Bank[]>(`${this.rootURL}payment/getbanks`);
  }

  initiateVCirclePayment(planid){
    return this.http.post(`${this.rootURL}payment/initiatevcirclepayment`, { planid }, {headers: new HttpHeaders({ "content-type": "application/json", "accept": "application/json" })});
  }

  initiateSchoolBillPayment(billId){
    //initiateschoolbillpayment
    return this.http.post(`${this.rootURL}payment/initiateschoolbillpayment`, { billId }, {headers: new HttpHeaders({ "content-type": "application/json", "accept": "application/json" })});
  }

  initiateStripeSchoolBillPayment(billId){    
    return this.http.post(`${this.rootURL}payment/initiateschoolbillpaymentwithstripe`, { billId }, {headers: new HttpHeaders({ "content-type": "application/json", "accept": "application/json" })});
  }

  initiateStripeModulePayment(moduleId, batchId){    
    return this.http.post(`${this.rootURL}payment/initiatemodulepaymentwithstripe`, { moduleId,batchId }, {headers: new HttpHeaders({ "content-type": "application/json", "accept": "application/json" })});
  }

  initiateStripePackagePayment(packageId){    
    return this.http.post(`${this.rootURL}payment/initiatepackagepaymentwithstripe`, { packageId }, {headers: new HttpHeaders({ "content-type": "application/json", "accept": "application/json" })});
  }

  createConnectAccount(email: string, isIndividualAccount: boolean) {
    var payload = JSON.stringify({
      email,
      isIndividualAccount,
    })
    return this.http.post(`${this.rootURL}payment/createschoolstripeaccount`, payload, {headers: new HttpHeaders({ "content-type": "application/json", "accept": "application/json" })});
  }
  createandGotoConnectAccountLink() {
    return this.http.post(`${this.rootURL}payment/createstripeaccountlink`, {headers: new HttpHeaders({ "content-type": "application/json", "accept": "application/json" })});
  }

  createProduct(productName, productDescription, productPrice, accountId) {
    return this.http.post(`${this.rootURL}payment/createstripeproduct`, {accountId}, {headers: new HttpHeaders({ "content-type": "application/json", "accept": "application/json" })});
  }
  getStripeAccountStatus(id: string){
    return this.http.get(`${this.rootURL}payment/stripeaccountstatus?id=${id}`);
  }

  async openStripeCheckout(toastr: ToastrService, clientSecret: string) {
    const stripe = await this.stripePromise;
    if (!stripe) {
      toastr.error('Stripe failed to load');
      return
    }
    
    this.checkout?.unmount();

    this.checkout = await stripe.createEmbeddedCheckoutPage({
      clientSecret: clientSecret
    });

    $('#stripeCheckout').modal('show');
    this.checkout.mount('#checkout');
    
  }
}
